module.exports = __webpack_public_path__ + "static/gallery-3-db8b2a8bcb462b37235211e69b865791.png";